export default "__VITE_ASSET__e6abf890__"